// import { uniqueKey } from 'global/common/keys';
import NoData from 'global/components/alerts/NoData';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
// import { sportsShowTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer';
import { useContext, useMemo } from 'react';
import { _standingsTypes } from './LeagueStandings';
// import StandingsLegend from './StandingsLegend';
// import StandingsWrapper from '../teams/StandingsWrapper';
// import { useSectionStandings } from 'projectSpecific/sports/useHelpers/useSectionStandings';
import { SectionStandingz } from './SectionStandingz';
import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
// import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
// import { sportsShowTypes } from '../cnr/reducers/SportsSeasonReducer';
// import { _standingsTypes } from '../elements/standings/LeagueStandings';
// import StandingsLegend from '../elements/standings/StandingsLegend';
// import StandingsWrapper from '../elements/teams/StandingsWrapper';
// import { useSectionStandings } from './useSectionStandings';

const LevelSectionStandings = ({
  _matchKey_page,
  _standingType,
  _teamKey_page,
  _teamsFavs,
  forOverview,
  forPlayoff,
  ms_levels,
  noData,
  playoffLevel,
  selectedLevelKey,
  showPlayoffPicture,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const {
    details_info,
    sportsShowType,
    gameScoringType
  } = sportsSeason_state ?? {};

  // const { details, sectionPlayoffTeams } = details_info ?? {};
  // const { playoffTeamsPerSection } = details ?? {};

  // const standingsLegend = useMemo(() => {
  //   if (!sectionPlayoffTeams) return null;
  //   return (
  //     <StandingsLegend
  //       playoffTeamsPerSection={playoffTeamsPerSection}
  //       sectionPlayoffTeams={sectionPlayoffTeams}
  //       gameScoringType={gameScoringType}
  //     />
  //   );
  // }, [playoffTeamsPerSection, sectionPlayoffTeams, gameScoringType]);

  const levelSectionsContent = () => {
    if (!ms_levels) return null;
    return _.map(ms_levels.items, lk => ({
      caption: lk,
      content: <SectionStandingz levelKey={lk} _teamsFavs={_teamsFavs} teamKey={_teamKey_page} matchKey={_matchKey_page} />,
    }));
  };

  const leagueStandings = useMemo(() => {
    if (showPlayoffPicture || playoffLevel) {
      return <SectionStandingz levelKey={playoffLevel} _teamsFavs={_teamsFavs} />
    }

    if (noData) {
      return <NoData fullCaption={'No Standings'} />;
    }

    if (forOverview || _teamKey_page) {
      return <SectionStandingz levelKey={levelKey} _teamsFavs={_teamsFavs} teamKey={_teamKey_page} matchKey={_matchKey_page} />
    }

    return (
      <MiniSwiper
        includeButtons={true}
        swipeItems={levelSectionsContent()}
        showButtons={true}
      />
    );
  }, [
    sportsShowType,
    _standingType,
    forOverview,
    playoffLevel,
    showPlayoffPicture,
    selectedLevelKey,
    levelSectionsContent,
  ]);

  return leagueStandings;
};

export default LevelSectionStandings;
